/** Papel "art" só entra no gerador com a flag de build ligada (gates G1/G2 — spec §10). */
export const isArtLabelsEnabled = (env = process.env) => env?.REACT_APP_ART_LABELS_ENABLED === "true";
